import React from "react";
import { Button, ButtonGroup, ButtonOr, Form, Header } from "semantic-ui-react";
import { useWindowWidth } from "@common/components/helpers/useWindowWidth";

export default function ToggleButtonGroup({
  value,
  options,
  onToggle = (value) => {},
  label = "",
  fieldStyle = "flex-between flex-row-center my-1",
  labelStyle = "p-0",
  showButtonOr = true,
}) {
  const width = useWindowWidth();

  return (
    <>
      <Form.Field className={fieldStyle}>
        <Header className={`${width > 700 ? "w-60" : "w-40"} ${labelStyle}`}>
          {label}
        </Header>
        <ButtonGroup>
          <Button
            color={value === options[0].value ? "green" : undefined}
            onClick={() => onToggle(options[0].value)}
          >
            {options[0].text}
          </Button>
          {showButtonOr && <ButtonOr />}
          <Button
            color={value === options[1].value ? "green" : undefined}
            onClick={() => onToggle(options[1].value)}
          >
            {options[1].text}
          </Button>
        </ButtonGroup>
      </Form.Field>
    </>
  );
}
